import ContactImage from '@/images/svg/location.svg';

export default class Common {
    constructor() {
        this.initMenuHeader();
    }

    initMenuHeader() {
        console.log('--- +++ ----');
        console.log(ContactImage);
    }
}
